<template>
  <div>
    <van-cell-group>
      <van-field v-model="datafrom.title" required label="标题" placeholder="请输入任务标题" />
    </van-cell-group>
    <van-cell-group>
      <!-- <van-cell-group>
        <van-field required v-model="datafrom.groupName" @click="fuwushow = true" readonly="readonly" label="发送组"
          placeholder="请选择发送组" />
        <van-popup v-model="fuwushow" position="bottom" get-container="body">
          <van-picker show-toolbar :columns="allGroupList" value-key="title" @cancel="fuwushow = false"
            @confirm="onfuwushow">
          </van-picker>
        </van-popup>
      </van-cell-group> -->
      <div class="activity-title">内容</div>
      <div>
        <Editor :value.sync="datafrom.content" style="width: 100%" />
      </div>
    </van-cell-group>

    <div>
      <span style="font-size: 14px; color: #333; margin: 0 17px">图片</span>
      <van-uploader v-model="fileList" multiple class="imgActivity" :max-count="9" :after-read="afterRead"
        :deletable="true" file-list ="fileList" @delete="shanchu" style="margin: 15px 22px" />
    </div>
    <div>
      <div style="margin-bottom: 10px; display: flex">
        <span style="font-size: 14px; color: #333; margin: 0 17px">视频</span>
        <!-- :before-read="beforeRead" -->
        <van-uploader max-count="1" accept=".mp4" :after-read="handleAvatarvideoSucces">
          <van-button icon="description" plain type="info">上传视频</van-button>
        </van-uploader>
      </div>
      <div style="display: inline-block; flex: 1;margin-left: 65px;" v-if="videoList.length != 0">
        <div v-for="(item, index) in videoList" :key="index" style="margin-bottom: 10px;">
          <a style="font-size: 14px; " :href="item" target="_blank">
            <span style="color: #4f4fef;">{{ item }}</span>
          </a>
          <van-icon style="margin-left: 10px" size="26px" color='#ff0000' name="delete-o"
            @click="shanvideochu(index)" />
        </div>
      </div>
    </div>
    <div>
      <div style="margin-bottom: 10px; display: flex">
        <span style="font-size: 14px; color: #333; margin: 0 17px">附件</span>
        <!-- :before-read="beforeRead" -->
        <van-uploader max-count="1" accept=".doc,.docx,.xls,.ppt,.txt,.pdf" :after-read="handleAvatarSucces">
          <van-button icon="description" plain type="info">上传附件</van-button>
        </van-uploader>
      </div>
      <div style="display: inline-block; flex: 1;margin-left: 65px;" v-if="flieList.length != 0">
        <div v-for="(item, index) in flieList" :key="index" style="margin-bottom: 10px;">
          <a style="font-size: 14px; " :href="item" target="_blank">
            <span style="color: #4f4fef;">{{ item }}</span>
          </a>
          <van-icon style="margin-left: 10px" size="26px" color='#ff0000' name="delete-o" @click="shanfilechu(index)" />
        </div>
      </div>
    </div>

    <div class="buttons">
      <van-button type="info" style="margin: 10px 0" @click="postfrom()">发布</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Dialog } from "vant";
import { Toast } from "vant";
import Editor from "@/components/Editor";
import config from "@/config";
import axios from "axios";
import { addTask, updateTask, getTask } from "@/api/task";
Vue.use(Toast);
export default {
  components: {
    Editor
  },
  data() {
    return {
      datafrom: {},
      uploadImgs: [],
      fuwushow: false,
      allGroupList: [],
      fileList: [],
      flieList: [],
      videoList: [],
      userId: '',
      id:''
    };
  },
  created() {
    // this.allGroupFun()
    this.userId = this.$route.query['userId']
    this.id = this.$route.query['id']
    if(this.id && this.id != 'undefined'){
      this.getUpdateInfo()
    }
  },
  methods: {
    // 获取所有分组
   /*  allGroupFun() {
      getAllGroup().then((response) => {
        this.allGroupList = response.data.data;
        console.log("getAllGroup", response);
      });
    }, */
    getUpdateInfo(){
      getTask(this.id).then((response) => {
        const info = response.data.data;
        this.datafrom = info
        if(info.img){
          this.uploadImgs = info.img.split(',')
          this.fileList = []
          this.uploadImgs.forEach(e => {
            const obj = {}
            obj.url = e
            this.fileList.push(obj)
          });
        }else{
          this.uploadImgs = []
        }
        if(info.video){
          this.videoList = info.video.split(',')
        }else{
          this.videoList = []
        }
        if(info.file){
          this.flieList = info.file.split(',')
        }else{
          this.flieList = []
        }
        console.log("getTask", response);
      });
    },
    // 提交
    postfrom: function () {
      console.log(this.datafrom, "this.datafrom");
      this.submitForm()
   },
    submitForm() {
      this.datafrom.userId = this.userId;
      console.log(this.datafrom);
      if (!this.datafrom.title) {
        this.$modal.msgError("请填写标题");
        return;
      }
  /*     if (!this.datafrom.groupCode) {
        this.$modal.msgError("请选择发送组");
        return;
      } */
      if (
        !this.datafrom.file &&
        !this.datafrom.video &&
        !this.datafrom.img &&
        !this.datafrom.content
      ) {
        this.$modal.msgError("内容，图片，视频，文件请选择一种上传或填写");
        return;
      }
          if (this.datafrom.id != null) {
            updateTask(this.datafrom).then((res) => {
              if (res.data.code == 0) {
          Toast.success("修改成功");
          setTimeout(() => {
            if (window.__wxjs_environment === "miniprogram") {
              // window.wx.miniProgram.redirectTo({
              //   url: "/pages/my/taskDistribution/index",
              // });
              window.wx.miniProgram.navigateBack({
                delta: 1
              });
            } else {
              this.$router.go(-1);
            }
          }, 1000);
          //   Dialog.alert({
          //     title: "提示",
          //     message: "提交成功!",
          //   }).then(() => {
          //     this.$router.push({
          //       path: "/CalYl/service",
          //     });
          //   });
        } else {
          Toast(res.data.msg);
          //   this.$router.go(-1);
        }
            });
          } else {
            addTask(this.datafrom).then((res) => {
              if (res.data.code == 0) {
          Toast.success("发布成功");
          setTimeout(() => {
            if (window.__wxjs_environment === "miniprogram") {
//               wx.navigateBack({
//   delta: 2
// })
              window.wx.miniProgram.navigateBack({
                delta: 1
                // url: "/pages/my/taskDistribution/index",
              });
            } else {
              this.$router.go(-1);
            }
          }, 1000);
        } else {
          Toast(res.data.msg);
        }
            });
          }
    },
    // 动态发送组选择器
    onfuwushow(val) {
      console.log(val);
      this.datafrom.groupCode = val.groupCode;
      this.datafrom.groupName = val.title;
      this.fuwushow = false;
    },
    // 上传 相关
    handleAvatarSucces(file) {
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      let c = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file);
      // 添加请求头
      axios.post(config.apiUploadUrl, formData, c).then((res) => {
        if (res.data.code === 0) {
          Toast.success("上传成功");
          var arr = this.flieList;
          arr.push(res.data.msg);
          this.flieList = arr;
        }
        this.datafrom.file = this.flieList + "";
      });
    },
    handleAvatarvideoSucces(file) {
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      let c = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file);
      // 添加请求头
      axios.post(config.apiUploadUrl, formData, c).then((res) => {
        if (res.data.code === 0) {
          Toast.success("上传成功");
          console.log(res.data)
          var arr = this.videoList;
          arr.push(res.data.msg);
          this.videoList = arr;
        }
        this.datafrom.video = this.videoList + "";
      });
    },
    // 图片上传
    afterRead(file) {
      let c = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file);
      // 添加请求头
      axios.post(config.apiUploadUrl, formData, c).then((res) => {
        if (res.data.code === 0) {
          var arr = this.uploadImgs;
          arr.push(res.data.msg);
          this.uploadImgs = arr;
        }
        this.datafrom.img = this.uploadImgs + "";
      });
    },
    // 图片删除
    shanchu: function (file, detail) {
      this.uploadImgs.splice(detail.index, 1);
      this.datafrom.img = this.uploadImgs + "";
    },
    shanvideochu(index) {
      this.videoList.splice(index, 1);
      this.datafrom.video = this.videoList + "";
    },
    shanfilechu(index) {
      this.flieList.splice(index, 1);
      this.datafrom.file = this.flieList + "";
    },
  }
};
</script>
<style scoped>
.activity-title {
  color: #646566;
  text-align: left;
  font-size: 14px;
  padding: 10px 16px;
}
.buttons {
  text-align: center;
}
.buttons button {
  margin: 25px 10px;
  width: 90%;
  border-radius: 10px;
}
</style>
